/* eslint-disable func-names */
import { Menubar } from '@taenzer-digital/bedrock';

import '../scss/manifest.scss';

import skipLinkFocusFix from './skip-link-focus-fix';

skipLinkFocusFix.init();

const menubar = new Menubar(document.getElementById('menubar'));
menubar.init();
